import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { OtpFacade } from '@domain/application/facade/otp/otp.facade';
import { SessionService } from '@domain/application/observable-services/session.service';
import { getCodeOtpFormInstance } from '@modules/business-accounts/forms/utils/otp/builders/otp-builder.class';
import { OtpValidationRequest } from '@utils/classes/request/otp-validation-request';
import { IOtpMailResponse } from '@utils/interfaces/response';
import { IStep } from '../../utils/interfaces/step.interface';
import { VisitEvent } from '@modules/business-accounts/utils/classes/visit-event.class';
import { TraceEventName } from '@modules/business-accounts/utils/enums/trace-events.enum';
import { TraceService } from '@modules/business-accounts/services/trace/trace.service';
import { FailedAttemptOtpModel } from '@utils/classes/model/failed-attempt-otp-model';
import { TraceError } from '@modules/business-accounts/utils/enums/trace-erros.enum';
import { AssetLink } from '@utils/helpers/asset-cpm-link';

@Component({
  selector: 'ba-validation-code-otp-step',
  templateUrl: './validation-code-otp-step.component.html',
  styleUrls: ['./validation-code-otp-step.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class ValidationCodeOtpStepComponent extends AssetLink() implements OnInit, IStep<FailedAttemptOtpModel> {
  @Output() stepDone = new EventEmitter<FailedAttemptOtpModel>();
  @Input() emailSelectedOtp: string = '';
  showValidationCodeOtpIncorrect: boolean = false;

  isLoading = false;
  firstName: string = '';
  showMsgResendCode: boolean = false;
  @Input() numberOfAttemptsOtpCode!: number;
  @Input() isClient: boolean = false;
  @Input() ruc: string = '';
  isPJ: boolean = false;
  disabledBtnSendCode: boolean = false;

  constructor(
    private readonly sessionService: SessionService,
    private readonly controlContainer: ControlContainer,
    private readonly otpFacade: OtpFacade,
    private readonly traceService: TraceService
  ) {
    super();
  }

  ngOnInit(): void {
    this.traceService.registerEvent(new VisitEvent(TraceEventName.PAGE_RENDER_OTP_VALIDATION_CODE));
    const { firstName } = this.sessionService.getCommonInfoValue;
    this.firstName = firstName + ',';
    this.isPJ = this.ruc != '' ? true : false;
    this.form.get('codeOtp')?.get('code')?.setValue('');
  }

  goToConfiguration() {
    this.isLoading = true;
    this.traceService.registerEvent(new VisitEvent(TraceEventName.ACTION_OTP_VALIDATION_CODE));
    const { signatureId } = this.sessionService.getCommonInfoValue;

    let otpValidationRequest: OtpValidationRequest = new OtpValidationRequest();
    otpValidationRequest.signatureId = signatureId;
    otpValidationRequest.code = this.form.get('codeOtp')?.get('code')?.value.toString();

    let failedAttemptOtpModel = new FailedAttemptOtpModel();
    this.otpFacade.otpValidation(otpValidationRequest).subscribe({
      next: () => {
        this.showValidationCodeOtpIncorrect = false;
        this.sessionService.setCommonInfo = { codeOtp: otpValidationRequest.code };
        this.isLoading = false;
        failedAttemptOtpModel = {
          showViewOtpError: false,
          showViewLockOtp: false,
          numberOfAttemptsOtpCode: this.numberOfAttemptsOtpCode,
        };
        this.stepDone.emit(failedAttemptOtpModel);
      },
      error: () => {
        this.isLoading = false;
        this.showValidationCodeOtpIncorrect = true;
        this.traceService.registerError(TraceError.OTP_VALIDATION_CODE_ERROR);
        this.numberOfAttemptsOtpCode = this.numberOfAttemptsOtpCode - 1;
        if (this.numberOfAttemptsOtpCode > 0) {
          failedAttemptOtpModel = {
            showViewOtpError: true,
            showViewLockOtp: false,
            numberOfAttemptsOtpCode: this.numberOfAttemptsOtpCode,
          };
          this.stepDone.emit(failedAttemptOtpModel);
        } else {
          failedAttemptOtpModel = {
            showViewOtpError: false,
            showViewLockOtp: true,
            numberOfAttemptsOtpCode: this.numberOfAttemptsOtpCode,
          };
          this.stepDone.emit(failedAttemptOtpModel);
        }
      },
    });
  }

  returnSendCode = (e: Event) => {
    e.preventDefault();
    this.traceService.registerEvent(new VisitEvent(TraceEventName.ACTION_OTP_RETRY_GET_CODE));
    const { otpMailRequest } = this.sessionService.getCommonInfoValue;
    this.otpFacade.otpMail(otpMailRequest).subscribe({
      next: (response: IOtpMailResponse) => {
        this.sessionService.setCommonInfo = { signatureId: response.signatureId };
        this.showMsgResendCode = true;
      },
      error: (error) => {
        console.log(error);
        this.disabledBtnSendCode = true;
      },
    });
  };

  closeMsgResendeCode() {
    this.showMsgResendCode = false;
  }

  get form() {
    return (this.controlContainer as FormGroupDirective).form;
  }

  get codeOtpForm() {
    return getCodeOtpFormInstance({ from: this.form });
  }

  getTextCapitalize(text: string) {
    let value = text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
    return value;
  }
}
